/*
 *
 * ResourceAndAssessmentDisclaimer actions
 *
 */

import { createAction } from 'redux-actions';
import {
  PROCESSING,
  GET_DISCLAIMER,
  GET_DISCLAIMER_SUCCESS,
} from './constants';

export const processing = createAction(PROCESSING);
export const getDisclaimer = createAction(GET_DISCLAIMER);
export const getDisclaimerSuccess = createAction(GET_DISCLAIMER_SUCCESS);
